module.exports = __webpack_public_path__ + "static/media/shop.79237047.jpg";